export const AREAS = {
  GRE: { code: 'GRE', label: 'Green', order: 1 },
  ROA: { code: 'ROA', label: 'Roasting', order: 2 },
  GRI: { code: 'GRI', label: 'Grinding', order: 3 },
  PAC: { code: 'PAC', label: 'Packaging', order: 4 },
  AUX: { code: 'AUX', label: 'Auxiliary', order: 5 }
};

export const LINE_DEFINITIONS = [
  { from: 1, to: 1, label: 'Roaster' },
  { from: 2, to: 2, label: 'Destoner' },
  { from: 3, to: 3, label: 'Afterburner' },
  { from: 4, to: 4, label: 'Line 4' },
  { from: 5, to: 5, label: 'Line 5' },
  { from: 6, to: 6, label: 'Line 6' },
  { from: 7, to: 7, label: 'Line 7' },
  { from: 8, to: 8, label: 'Line 8' },
  { from: 9, to: 9, label: 'Line 9' },
  { from: 10, to: 19, label: 'Transport to Silo' },
  { from: 20, to: 29, label: 'Cleaning' },
  { from: 30, to: 39, label: 'Silo/Storage' },
  { from: 40, to: 49, label: 'Blender' },
  { from: 50, to: 59, label: 'Conveyor' },
  { from: 60, to: 69, label: 'Dedusting' },
  { from: 70, to: 79, label: 'Packing Machine' },
  { from: 80, to: 89, label: 'Palletiser' },
  { from: 90, to: 99, label: 'Metal Detector' },
  { from: 100, to: 199, label: 'Transport' },
  { from: 200, to: 299, label: 'Degas System' },
  { from: 300, to: 399, label: 'Nitrogen System' },
  { from: 400, to: 499, label: 'Compressor / Air' },
  { from: 500, to: 599, label: 'Electrical Panel' },
  { from: 600, to: 699, label: 'Software / Controls' },
  { from: 700, to: 799, label: 'Installation' },
  { from: 800, to: 899, label: 'Spare Parts' },
  { from: 900, to: 949, label: 'Training' },
  { from: 950, to: 990, label: 'Miscellaneous' }
];

export function getLineLabel(lineNumber) {
  const num = Number(lineNumber);
  const def = LINE_DEFINITIONS.find((d) => num >= d.from && num <= d.to);
  if (!def) return `Line ${num}`;
  if (def.from === def.to) return def.label;
  return `${def.label} ${num - def.from + 1}`;
}

export function getAreasSorted() {
  return Object.values(AREAS).sort((a, b) => a.order - b.order);
}

export function getLineOptions() {
  const options = [];
  for (const def of LINE_DEFINITIONS) {
    if (def.from === def.to) {
      options.push({ value: String(def.from), label: `${String(def.from).padStart(3, '0')} - ${def.label}` });
    } else {
      for (let i = def.from; i <= def.to; i++) {
        const suffix = i - def.from + 1;
        options.push({ value: String(i), label: `${String(i).padStart(3, '0')} - ${def.label} ${suffix}` });
      }
    }
  }
  return options;
}

export const AREA_CODES = Object.keys(AREAS);

export const STATUS_LABELS = {
  0: 'Draft',
  1: 'Ready',
  2: 'Accepted',
  3: 'Rejected',
  4: 'Superseded'
};

export const STATUS_BADGE_TONES = {
  0: undefined,
  1: 'info',
  2: 'success',
  3: 'critical',
  4: 'warning'
};

export const UNIT_DEFINITIONS = [
  { base: 0, label: 'Varia/Mech/Struct' },
  { base: 100, label: 'Dosing Scale' },
  { base: 200, label: 'Buffer' },
  { base: 300, label: 'Roaster' },
  { base: 400, label: 'Sifter' },
  { base: 500, label: 'Intersection' },
  { base: 600, label: 'Grinder' },
  { base: 700, label: 'Packaging Machine' },
  { base: 800, label: 'Cell' },
  { base: 900, label: 'OPC UA' },
  { base: 1100, label: 'Arm' },
  { base: 1300, label: 'Manual on off node' },
  { base: 1400, label: 'Button' },
  { base: 1500, label: 'Select' },
  { base: 1600, label: 'Null' },
  { base: 1700, label: 'General Scale' },
  { base: 1800, label: 'Intersection Multi' },
  { base: 1900, label: 'Rotary Lock' },
  { base: 2000, label: 'Big Bag' },
  { base: 2100, label: 'Shrinkage Scale' },
  { base: 2200, label: 'Switch board' },
  { base: 2300, label: 'Button board' },
  { base: 2400, label: 'Text field' },
  { base: 2500, label: 'Tag display' },
  { base: 2600, label: 'Valve' },
  { base: 2700, label: 'Coffee Detection' },
  { base: 2800, label: 'Input board' },
  { base: 2900, label: 'Pump' },
  { base: 3000, label: 'Pressure Meter' },
  { base: 3100, label: 'Nerak' },
  { base: 3200, label: 'Disc' },
  { base: 3300, label: 'Dust Aspiration' },
  { base: 3400, label: 'Safety' },
  { base: 3500, label: 'Electrical' },
  { base: 3600, label: 'Signaling' },
  { base: 3700, label: 'Belt' },
  { base: 3800, label: 'Filter' },
  { base: 3900, label: 'Dosing Screw' }
];

export function getUnitBase(unitNumber) {
  return Math.floor(unitNumber / 100) * 100;
}

export function getUnitTypeLabel(unitNumber) {
  const base = getUnitBase(unitNumber);
  const def = UNIT_DEFINITIONS.find((d) => d.base === base);
  return def ? def.label : `Unit ${unitNumber}`;
}

export function getUnitLabel(unitNumber) {
  const num = Number(unitNumber);
  const base = getUnitBase(num);
  const def = UNIT_DEFINITIONS.find((d) => d.base === base);
  if (!def) return `Unit ${num}`;
  const instance = num - base;
  if (instance === 0) return def.label;
  return `${def.label} ${String(instance).padStart(2, '0')}`;
}

export function getUnitOptions() {
  return UNIT_DEFINITIONS.map((d) => ({
    value: String(d.base),
    label: `${String(d.base).padStart(4, '0')} - ${d.label}`
  }));
}
